/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
// import CustomerForm from '../../../../app/pages/Customer/Customer'

export function AsideMenuMain() {
  const intl = useIntl()

  // Get the role stored in localStorage
  const userRole = localStorage.getItem('who')

  return (
    <>
      {userRole && ['super_admin', 'Admin', 'AccountUser', 'Consignment user', 'Director', 'SalesUser', 'Supervisor'].includes(userRole) && (
        <AsideMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/art/art002.svg'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        />
      )}


      {['Supervisor', 'AccountUser', 'Admin', 'super_admin', 'Director', 'Consignment user'].includes(userRole ?? '') && (
        <div style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <AsideMenuItem
            to='/customerTable'
            title='Customer'
            icon='/media/icons/duotune/communication/com006.svg'
            fontIcon='bi-person'
          />
        </div>
      )}


      {['super_admin', 'Admin'].includes(userRole ?? '') && (
        <div style={{ paddingBottom: '10px' }}>
          <AsideMenuItem
            to='/user'
            title='User'
            icon='/media/icons/duotune/general/gen008.svg'
            fontIcon='bi-person'
          />
        </div>
      )}

      {['super_admin', 'Admin', 'Director'].includes(userRole ?? '') && (
        <div style={{ paddingBottom: '10px' }}>
          <AsideMenuItem
            to='/hubtable'
            title='Hub'
            icon='/media/icons/duotune/ecommerce/ecm004.svg'
            fontIcon='bi-person'
          />
        </div>
      )}

      {!['AccountUser'].includes(userRole ?? '') && (
        <div style={{ paddingBottom: '10px' }}>
          <AsideMenuItem
            to='/bookingtable'
            title='Booking'
            icon='/media/icons/duotune/ecommerce/ecm002.svg'
            fontIcon='bi-person'
          />
        </div>
      )}


      <div style={{ paddingBottom: '10px' }}>
        <AsideMenuItem
          to='/shipment'
          title='Shipment'
          icon='/media/icons/duotune/ecommerce/ecm006.svg'
          fontIcon='bi-person'
        />
      </div>
      {!['SalesUser', 'Supervisor'].includes(userRole ?? '') && (
        <div style={{ paddingBottom: '10px' }}>
          <AsideMenuItem
            to='/expenses'
            title='Expenses'
            icon='/media/icons/duotune/ecommerce/ecm003.svg'
            fontIcon='bi-person'
          />
        </div>
      )}
      {!['SalesUser', 'Supervisor', 'Consignment user'].includes(userRole ?? '') && (
        <div style={{ paddingBottom: '10px' }}>
          <AsideMenuItemWithSub
            to='/reports'
            title='Reports'
            icon='/media/icons/duotune/general/gen032.svg'
            fontIcon='bi-person'
          >
            <AsideMenuItem to='/reports/dailyreports' title='Daily Collection Reports' hasBullet={true} />
            <AsideMenuItem to='/reports/monthlyreports' title='Monthly P&L Reports' hasBullet={true} />
            <AsideMenuItem to='/reports/jobreport' title='Job Reports' hasBullet={true} />
            <AsideMenuItem to='/reports/outstandingreports' title='Outstanding Reports' hasBullet={true} />
          </AsideMenuItemWithSub>


        </div>
      )}

      <div style={{ paddingBottom: '10px' }}>
        <AsideMenuItem
          to='/pendingpayment'
          title='Pay Now'
          icon='/media/icons/duotune/finance/fin010.svg'
          fontIcon='bi-person'

        />

      </div>

      {/* <div style={{ paddingBottom: '10px' }}>
        <AsideMenuItem
          to='/profilepage'
          title='Profile'
          icon='/media/icons/duotune/communication/com006.svg'
          fontIcon='bi-person'

        />
      </div> */}

      {/* <AsideMenuItem
        to='/customer'
        icon='/media/icons/duotune/general/gen022.svg'
        title='customerform'
        fontIcon='bi-app-indicator'
      /> */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Customer</span>
        </div>
      </div> */}

      {/* <AsideMenuItemWithSub
        to='/customer'
        title='Customer'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/dashboard' title='Customer Table' hasBullet={true} />
        <AsideMenuItem to='/customer' title='Customer Add' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>User</span>
        </div>
      </div>

      <AsideMenuItemWithSub
        to='/user'
        title='User'
        icon='/media/icons/duotune/general/gen008.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/user' title='User List' hasBullet={true} />
        <AsideMenuItem to='/adduser' title='Add User' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Hub</span>
        </div>
      </div> */}

      {/* <AsideMenuItemWithSub
        to='/hubtable'
        title='Hub'
        icon='/media/icons/duotune/ecommerce/ecm004.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/hubtable' title='Hub Table' hasBullet={true} />
        <AsideMenuItem to='/hubpoint' title='Hub' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      {/* <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Shipment</span>
          </div>
        </div> */}

      {/* <AsideMenuItemWithSub
        to='/shipment'
        title='Shipment'
        icon='/media/icons/duotune/ecommerce/ecm006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/shipment' title='Shipment' hasBullet={true} />
        <AsideMenuItem to='/shipmentform' title='Shipment Add' hasBullet={true} />
        <AsideMenuItem to='/bookingtable' title='Booking Table' hasBullet={true} />
        <AsideMenuItem to='/bookingform' title='Booking Add' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      {/* <AsideMenuItem
        to='/sucess'
        title='SucessPage'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/failure'
        title='Error Page'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/adduser'
        title='Add User'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/user'
        title='User'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/hubpoint'
        title='Hub'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/bookingform'
        title='Booking Form'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/shipment'
        title='Shipment Table'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/bookingtable'
        title='Booking Table'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />
      <AsideMenuItem
        to='/shipmentform'
        title='Shipment Form'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      /> */}
      {/* <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      {/* <AsideMenuItem
        to='/auth/registration'
        title='Registration'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      /> */}

      {/* <AsideMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Layout Builder'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <AsideMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <AsideMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
          <AsideMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <AsideMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/error'
        title='Errors'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen040.svg'
      >
        <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='/media/icons/duotune/general/gen025.svg'
        fontIcon='bi-layers'
      >
        <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <AsideMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}